import FooterMultiForm from './footerMultiForm'

export default FooterMultiForm